import Dev from "@frog/source/models/admin/Dev.js"
import Geometry from "@frog/source/utility/Geometry.js"
import unitTemplates from "@frog/source/data/unitTemplates.js"
import shortid from "shortid"
import Objdict from "objdict"

const tilesize = 10.0
const gridMax = 4
const roomSize = 4
const gridMargin = 2
const chapterWidth = gridMax*(roomSize+1)+gridMargin*2
const chapterHeight = gridMax*(roomSize+1)+gridMargin*2

class Dungeon {
    constructor(level) {
        this.rooms = []
        this.roomGrid = [...Array(gridMax)].map(e => Array(gridMax))

        let encounterX = 2
        let encounterY = 2
        let previousRoom = undefined
        //Array(0,1,2,3,4,5).forEach((roomNumber) => {
        for(let roomNumber = 0; roomNumber < 6; roomNumber++) {
            const newRoom = new FourstationRoom(roomNumber+1,
                gridMargin+encounterX*(roomSize+1),
                gridMargin+encounterY*(roomSize+1),roomSize,roomSize,level)
            this.rooms.push(newRoom)
            this.roomGrid[encounterX][encounterY] = newRoom

            // TODO: place doors
            // newRoom.doorX = (previousRoom.x-newRoom.x)

            newRoom.previousRoom = previousRoom
            previousRoom = newRoom

            let nextDirections = Array([1,0],[0,1],[-1,0],[0,-1])
            nextDirections = nextDirections.filter((direction) => {
                return (
                    encounterX+direction[0] < gridMax
                    && encounterX+direction[0] >= 0
                    && encounterY+direction[1] < gridMax
                    && encounterY+direction[1] >= 0
                    && this.roomGrid[encounterX+direction[0]][encounterY+direction[1]] == undefined
                )
            })
            if(nextDirections.length == 0) break
            const randomDirection = nextDirections[Math.floor(Math.random()*nextDirections.length)]
            encounterX += randomDirection[0]
            encounterY += randomDirection[1]
        }
    }
    generateEnvironmentArt(color) {
        const myCanvas = document.createElement("canvas")
        const ctx = myCanvas.getContext('2d')
        ctx.canvas.width = chapterWidth*tilesize
        ctx.canvas.height = chapterHeight*tilesize

        ctx.fillStyle = "rgb("+color.R/3+","+color.G/3+","+color.B/3+")"
        ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)

        this.rooms.forEach((room) => {
            room.generateEnvironmentArt(ctx,color)
        })

        return myCanvas.toDataURL()
    }
    generateUnits() {
        let generatedUnits = []

        this.rooms.forEach((room) => {
            generatedUnits = Object.assign({}, generatedUnits, room.units)
        })

        return generatedUnits
    }
    generateWorld() {
        const world = {
            "width": chapterWidth,
            "height": chapterHeight,
            "zones": {},
        }

        this.rooms.forEach((room) => {
            world.zones[room.encounter.slug] = room.encounter
            world.terrain = Object.assign({}, world.terrain, room.terrain)
        })

        return world
    }
}

function fillTilesRectangle(ctx,leftCornerX,topCornerY, width,height) {
    ctx.fillRect(leftCornerX*tilesize,topCornerY*tilesize,
        width*tilesize,height*tilesize)
}
class SquareRoom {
    constructor(slug, leftCornerX,topCornerY, width,height,level) {
        this.cornerX = leftCornerX
        this.cornerY = topCornerY
        this.width = width
        this.height = height
        this.slug = slug

        this.groundColor = []
        this.groundColor.R = 80
        this.groundColor.G = 50
        this.groundColor.B = 100

        this.doorX = 0
        this.doorY = 0

        this.tiles = new Tiles
        for(let tileX = 0; tileX < width; tileX++) {
            for(let tileY = 0; tileY < height; tileY++) {
                this.tiles.push(new Tile(this.cornerX+tileX,this.cornerY+tileY))
            }
        }
        this.generateRoom(level)
    }
    generateRoom(level){
        this.encounter = this.generateEncounter()
        this.terrain = {}
        this.generateTerrain()
        this.units = this.generateUnits()
    }
    generateEnvironmentArt(ctx, color) {
        ctx.fillStyle = "rgb("+color.R+","+color.G+","+color.B+")"
        fillTilesRectangle(ctx,this.cornerX,this.cornerY,this.width,this.height)
        fillTilesRectangle(ctx,this.cornerX+this.doorX,this.cornerY+this.doorY,1,1)
    }
    generateEncounter() {
        const points = []
        const corners = new Array(
            {"x": 0, "y": 0},
            {"x": 1, "y": 0},
            {"x": 1, "y": 1},
            {"x": 0, "y": 1}
        )
        corners.forEach((corner) => {
            points.push({
                "x": corner.x*this.width+this.cornerX,
                "y": corner.y*this.height+this.cornerY,
            })
        })
        const encounter = {
            "slug": this.slug,
            "name": this.slug == 6 ? "The Boss" : undefined,
            "zoomout": 1,
            "points": points,
        }

        // We expect all points to be defined in clockwise
        // order, particularly for rendering the polygon.
        // If the encounter was defined counterclockwise,
        // go ahead and reverse the order of the points.
        // We can check if the encounter was defined in
        // counterclockwise order by computing the area.
        // If its area is negative, it is counterclockwise.
        encounter.area = Geometry.area(encounter.points)
        if(encounter.area < 0) encounter.points.reverse()

        encounter.points.forEach((point, index) => {
            const a = encounter.points[(index + 0) % encounter.points.length]
            const b = encounter.points[(index + 1) % encounter.points.length]
            const c = encounter.points[(index + 2) % encounter.points.length]
            b.internalAngle = Geometry.direction(a, c)
            b.internalAngle = Geometry.rotate(b.internalAngle, 90)
        })

        encounter.x1 = Math.min(...encounter.points.map((point) => point.x))
        encounter.x2 = Math.max(...encounter.points.map((point) => point.x))
        encounter.y1 = Math.min(...encounter.points.map((point) => point.y))
        encounter.y2 = Math.max(...encounter.points.map((point) => point.y))
        encounter.z = 1
        encounter.x = encounter.x1
        encounter.y = encounter.y1
        encounter.width = encounter.x2 - encounter.x1
        encounter.height = encounter.y2 - encounter.y1
        encounter.center = {
            "x": encounter.x + ((encounter.x2 - encounter.x1) / 2) + 0.5,
            "y": encounter.y + ((encounter.y2 - encounter.y1) / 2) + 0.5
        }
        encounter.zone = encounter

        return encounter
    }
    generateTerrain() {
        this.tiles.forEach((tile) => {
            this.terrain[tile.x + "x" + tile.y] = {
                "position": {"x": tile.x, "y": tile.y, "z": 0},
                "size": {"x": 1, "y": 1, "z": 1},
            }
            this.terrain[tile.x + "x" + tile.y].hasCollision = false
        })
    }
    generateUnits() {
        const units = []
        this.tiles.forEach((tile) => {
            tile.randomizationWeight = 1
        })
        let heroKeys = ["swordlord", "spearknight", "axeknight", "highpriest", "daggercloak", "gunner"]
        Array(0,1,2).forEach((heroNumber) => {
            const randomTile = this.tiles.sampleRandomTile()
            if(this.slug == 1) {
                const newKey = heroKeys[Math.floor(Math.random()*heroKeys.length)]
                placeNewUnit(units,unitTemplates["player/" + newKey],randomTile.x,randomTile.y,true)
                heroKeys.splice(heroKeys.indexOf(newKey),1)
            } else {
                placeNewUnit(units,unitTemplates["spawnspot"],randomTile.x,randomTile.y)
            }
            randomTile.randomizationWeight = 0
        })
        Array(0,1,2).forEach((foeNumber) => {
            const randomTile = this.tiles.sampleRandomTile()
            placeNewUnit(units,unitTemplates["randoms/basic"],randomTile.x,randomTile.y)
            randomTile.randomizationWeight = 0
        })
        return units
    }
}
const CARDINAL_DIRECTIONS = {
    "northwest": {
        "x": -1,
        "y": -1,
    },
    "northeast": {
        "x": 1,
        "y": -1,
    },
    "southwest": {
        "x": -1,
        "y": 1,
    },
    "southeast": {
        "x": 1,
        "y": 1,
    },
}
const CARDINAL_CORNERS = {
    "northwest": {
        "x": 0,
        "y": 0,
    },
    "northeast": {
        "x": 2,
        "y": 0,
    },
    "southwest": {
        "x": 0,
        "y": 2,
    },
    "southeast": {
        "x": 2,
        "y": 2,
    },
}
function randomStation() {
    const stations = [
        [
            [{"collision": true},{"collision": true}],
            [{"unit": true},{"unit": true}]
        ],
        [
            [{"unit": true},{"collision": true}],
            [{"unit": true},{"collision": true}]
        ],
        [
            [{"collision": true},{"unit": true}],
            [{"unit": true},{}]
        ],
        [
            [{},{"unit": true}],
            [{"unit": true},{"collision": true}]
        ],
        [
            [{"unit": true},{}],
            [{"unit": true},{}],
        ],
        [
            [{},{}],
            [{"unit": true},{"unit": true}],
        ],
        [
            [{}, {"unit": true}],
            [{"unit": true}, {}]
        ],
    ]
    const keys = Object.keys(stations)
    let station = stations[keys[Math.floor(keys.length * Math.random())]]
    if(Math.random() < 0.5) {
        let flippedStation = structuredClone(station)
        flippedStation[0][0] = station[1][0]
        flippedStation[1][0] = station[0][0]
        flippedStation[0][1] = station[1][1]
        flippedStation[1][1] = station[0][1]
        station = flippedStation
    }
    if(Math.random() < 0.5) {
        let flippedStation = structuredClone(station)
        flippedStation[0][0] = station[0][1]
        flippedStation[1][0] = station[1][1]
        flippedStation[0][1] = station[0][0]
        flippedStation[1][1] = station[1][0]
        station = flippedStation
    }
    return station
}
class FourstationRoom extends SquareRoom {
    generateRoom(level){
        this.encounter = this.generateEncounter()

        this.stations = {}
        this.stations["northwest"] = randomStation()
        this.stations["northeast"] = randomStation()
        this.stations["southeast"] = randomStation()
        this.stations["southwest"] = randomStation()

        this.terrain = {}
        this.generateTerrain()
        this.units = this.generateUnits(level)

        const fromTile = this.tiles.sampleRandomTile()
        const reachableTiles = computeReachability(fromTile,this.tiles)
        Object.entries(this.units).forEach(([key,unit]) => {
            if(reachableTiles.tileAt(unit.position.x,unit.position.y)?.reachableDistance == undefined) {
                this.generateRoom(level)
            }
        })
    }
    generateEnvironmentArt(ctx,color) {
        ctx.fillStyle = "rgb("+color.R+","+color.G+","+color.B+")"
        fillTilesRectangle(ctx,this.cornerX,this.cornerY,this.width,this.height)
        fillTilesRectangle(ctx,this.cornerX+this.doorX,this.cornerY+this.doorY,1,1)
        Object.entries(this.stations).forEach(([key,value]) => {
            const stationCornerX = this.cornerX+CARDINAL_CORNERS[key].x
            const stationCornerY = this.cornerY+CARDINAL_CORNERS[key].y
            let y = stationCornerY
            value.forEach((row) => {
                let x = stationCornerX
                row.forEach((element) => {
                    if(element.collision == true) {
                        ctx.fillStyle = "rgb("+color.R/3+","+color.G/3+","+color.B/3+")"
                        fillTilesRectangle(ctx,x,y,1,1)
                    }
                    x += 1
                })
                y += 1
            })
        })
    }
    generateTerrain() {
        this.tiles.forEach((tile) => {
            this.terrain[tile.x + "x" + tile.y] = {
                "position": {"x": tile.x, "y": tile.y, "z": 0},
                "size": {"x": 1, "y": 1, "z": 1},
            }
            this.terrain[tile.x + "x" + tile.y].hasCollision = false
            tile.terrain = this.terrain[tile.x + "x" + tile.y]
        })
        Object.entries(this.stations).forEach(([key,value]) => {
            const stationCornerX = this.cornerX+CARDINAL_CORNERS[key].x
            const stationCornerY = this.cornerY+CARDINAL_CORNERS[key].y
            let y = stationCornerY
            value.forEach((row) => {
                let x = stationCornerX
                row.forEach((element) => {
                    if(element.collision == true) {
                        this.terrain[x + "x" + y].hasCollision = true
                    }
                    x += 1
                })
                y += 1
            })
        })
    }
    generateUnits(level) {
        const units = []
        this.tiles.forEach((tile) => {
            tile.randomizationWeight = 1
        })
        let heroKeys = structuredClone(level.partyPicks)
        //let heroKeys = ["swordlich", "spearknight", "axeknight", "highpriest", "daggercloak", "gunner"]
        let entityCounter = 0
        let hasSpawnedHobgoblin = false
        Object.entries(this.stations).forEach(([key,value]) => {
            const stationCornerX = this.cornerX+CARDINAL_CORNERS[key].x
            const stationCornerY = this.cornerY+CARDINAL_CORNERS[key].y
            let y = stationCornerY
            value.forEach((row) => {
                let x = stationCornerX
                row.forEach((element) => {
                    if(element.unit == true) {
                        if(entityCounter < 4 && heroKeys.length > 0) {
                            if(this.slug == 1) {
                                const newKey = heroKeys[Math.floor(Math.random()*heroKeys.length)]
                                let newUnit = {"key": newKey}
                                placeNewUnit(units,newUnit,x,y,true)
                                this.tiles.tileAt(x,y).randomizationWeight = 0
                                heroKeys.splice(heroKeys.indexOf(newKey),1)
                            } else {
                                placeNewUnit(units,unitTemplates["spawnspot"],x,y)
                                this.tiles.tileAt(x,y).randomizationWeight = 0
                            }
                        } else {
                            let newUnit = {
                                "randomJobKey": level.enemyJobs,
                                "affiliation": "bad",
                                "faceKey": "goblin"
                            }
                            if(this.slug == "6"
                            && hasSpawnedHobgoblin == false) {
                                newUnit.faceKey = "hobgoblin"
                                newUnit.maxhealth = 20
                                hasSpawnedHobgoblin = true
                            }
                            placeNewUnit(units,newUnit,x,y)
                            this.tiles.tileAt(x,y).randomizationWeight = 0
                        }
                        entityCounter += 1
                    }
                    x += 1
                })
                y += 1
            })
        })
        return units
    }
}

function computeReachability(goalTile,reachableTiles) {
    reachableTiles.forEach((tile) => {tile.reachableDistance = undefined})

    reachableTiles.tileAt(goalTile.x,goalTile.y).reachableDistance = 0
    for(let counter = 0; counter < 10; counter++) {
        let reachableTilesAtPreviousStep = reachableTiles.copy()
        reachableTiles.forEach((tile) => {
            const directions = Array(
                [1,0],
                [0,1],
                [-1,0],
                [0,-1]
            )
            directions.forEach((direction) => {
                const neighborTile = reachableTilesAtPreviousStep.tileAt(tile.x+direction[0],tile.y+direction[1])
                if(neighborTile == undefined) return
                if(neighborTile.terrain.hasCollision == true) return

                const distanceToReachNeighbor = 1+neighborTile.reachableDistance
                if(isNaN(distanceToReachNeighbor)) return

                if(tile.reachableDistance == undefined
                || tile.reachableDistance > distanceToReachNeighbor) {
                    tile.reachableDistance = distanceToReachNeighbor
                }
            })
        })
    }

    return reachableTiles
}

class Tiles {
    constructor() {
        this.list = []
    }
    tileAt(x,y) {
        return this.list.filter((tile) => (tile.x == x && tile.y == y))[0]
    }
    push(tile) {
        this.list.push(tile)
    }
    forEach(handler) {
        this.list.forEach(handler)
    }
    sampleRandomTile() {
        let totalTileWeight = 0
        this.list.forEach((tile) => {
            totalTileWeight += tile.randomizationWeight
        })
        const pulledCumulativeMass = Math.random()*totalTileWeight
        let weightCounter = 0
        let sampledTile = undefined
        this.list.forEach((tile) => {
            if(weightCounter < pulledCumulativeMass) {
                weightCounter += tile.randomizationWeight
                if(weightCounter > pulledCumulativeMass) {
                    sampledTile = tile
                }
            }
        })
        if(sampledTile == undefined) console.log("failed to sample a tile")
        return sampledTile
    }
    copy() {
        const copyTiles = new Tiles
        copyTiles.list = structuredClone(this.list)
        return copyTiles
    }
}
class Tile {
    constructor(x,y) {
        this.x = x
        this.y = y
    }
}

// === SUPPORT FUNCTIONS === //

function placeNewUnit(units,template,x,y,isPartyMember=false) {
    const baseUnit = {
        "position": {
            "x": x,
            "y": y,
            "z": 1
        },
    }
    const newUnit = Objdict.merge(baseUnit,template)
    if (isPartyMember == false) {
        newUnit.key = shortid.generate()
    }
    units[newUnit.key] = newUnit
}
function findUnitsAtPosition(units,x,y) {
    return Object.values(units).filter((unit) => {
        return unit.position.x == x
            && unit.position.y == y
    })
}

export default Dungeon
